import { CardHeader, CardHeaderTypeMap, Icon, Tooltip } from '@material-ui/core';
import { Block } from '@material-ui/icons';
import React from 'react';
import { theme } from '../theme';

export interface FluentCardHeaderProps {
  action?: CardHeaderTypeMap['props']['action'];
  disabled?: boolean;
  title: string;
  disabledIconTooltip: string;
}

// Maybe repurpose away from passing disabled to having the consumer choose an optional icon
export const FluentCardHeader = ({
  action,
  disabled = false,
  title,
  disabledIconTooltip,
}: FluentCardHeaderProps): JSX.Element => {
  return (
    <CardHeader
      action={disabled ? null : action}
      title={
        <div style={{ display: 'flex' }}>
          {disabled && (
            <Tooltip arrow={true} placement="top" title={disabledIconTooltip}>
              <Icon
                style={{
                  color: theme.palette.secondary.main,
                  marginTop: -2, // The Block svg itself has extra pixels at the top of the image
                }}
              >
                <Block />
              </Icon>
            </Tooltip>
          )}
          <span style={{ paddingLeft: 14 }}>{title}</span>
        </div>
      }
      style={{
        alignItems: 'center',
      }}
    />
  );
};
